module.exports = "varying vec3 vColor;\n\nvoid main() { gl_FragColor = vec4(vColor, 1.0); }"